import React from 'react'

const DashboardIndex = () => {
  return (
    <>
    
    </>
     
   
  )
}

export default DashboardIndex
